import type { User } from '@/types'

/**
 * Get the role name from a user object
 * Checks multiple possible locations where role name might be stored
 */
export function getUserRoleName(user: User | null): string | null {
  if (!user) return null
  
  // Check role_name or user_role_name from API (preferred)
  const roleName = (user as any)?.role_name || (user as any)?.user_role_name
  if (roleName) return roleName
  
  // Check user_role object/string
  const userRole = (user as any)?.user_role
  if (userRole) {
    if (typeof userRole === 'string') {
      try {
        const parsed = JSON.parse(userRole)
        return parsed?.name || null
      } catch {
        return null
      }
    } else if (typeof userRole === 'object' && userRole?.name) {
      return userRole.name
    }
  }
  
  // Fallback to role field
  return (user as any)?.role || null
}

/**
 * Check if user is a Senior Team Lead or Team Lead
 */
export function isTeamLead(user: User | null): boolean {
  const roleName = getUserRoleName(user)
  return roleName === 'Senior Team Lead' || roleName === 'Team Lead'
}

/**
 * Check if user is a Senior Team Lead
 */
export function isSeniorTeamLead(user: User | null): boolean {
  const roleName = getUserRoleName(user)
  return roleName === 'Senior Team Lead'
}

/**
 * Check if user is a Team Lead (but not Senior Team Lead)
 */
export function isRegularTeamLead(user: User | null): boolean {
  const roleName = getUserRoleName(user)
  return roleName === 'Team Lead'
}
